import React from 'react';
import {
  OpportunityCalculatorFeatureChip,
  OpportunityCalculatorFeatureChipsBlock,
  OpportunityCalculatorGrid,
  OpportunityCalculatorTextBlock,
} from './OpportunityCalculatorContent.styles';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import CheckCircle from 'src/images/2023_Q4/CheckCircle';
import SliderCalculatorForAnnualRevenue from 'src/molecules/Shared/2024_Q1_people_magic/SliderCalculatorForAnnualRevenue/SliderCalculatorForAnnualRevenue';

interface OpportunityCalculatorContentProps {
  title?: string;
  descriptions?: string[];
}

const featureChipsCommunityPlatform = [
  'Charge a one-time or recurring fee',
  'Offer free trials and bundles',
  'Charge in 135+ currencies or even token-gate',
];

const OpportunityCalculatorContent = ({
  title = 'It’s not just easier on Mighty. It’s more profitable.',
  descriptions = [
    'People just like you are charging $48/month for a paid membership or $500+ for a course or event on their Mighty Network.',
    'See what you could earn with our revenue calculator—you don’t need a huge audience to build a big business.',
  ],
}: OpportunityCalculatorContentProps): JSX.Element => {
  return (
    <OpportunityCalculatorGrid>
      <OpportunityCalculatorTextBlock>
        <Heading
          standardSize='2.5'
          align='left'
          className='opportunity-calculator-heading'
          text={title}
        />
        {descriptions.map((description, index) => (
          <Paragraph
            key={index}
            standardSize='1.5'
            className='opportunity-calculator-paragraph'
            text={description}
          />
        ))}
        <OpportunityCalculatorFeatureChipsBlock>
          {featureChipsCommunityPlatform.map((chip, index) => (
            <OpportunityCalculatorFeatureChip key={index}>
              <CheckCircle
                color={'accentBlue'}
                width={20}
              />
              <Paragraph
                text={chip}
                standardSize='1'
                align='left'
                weight={700}
              />
            </OpportunityCalculatorFeatureChip>
          ))}
        </OpportunityCalculatorFeatureChipsBlock>
      </OpportunityCalculatorTextBlock>
      <SliderCalculatorForAnnualRevenue />
    </OpportunityCalculatorGrid>
  );
};

export default OpportunityCalculatorContent;
